import DefaultList from "@/components/DefaultList";
import { Module, PATH_CLIENT } from "@/constants";
import { readClient } from "@/schemas/client";
import { ReadClient } from "@/types/client";
import { ClientService } from "../service";
import { generatePath } from "react-router-dom";

const ClientList = () => (
  <DefaultList<ReadClient>
    schema={readClient}
    name={Module.Clients}
    fetchList={ClientService.getList}
    pathBuilder={(row) =>
      generatePath(PATH_CLIENT, {
        clientId: row.id,
      })
    }
    tableFeatures={{
      exportSettings: { moduleName: Module.Clients },
    }}
  />
);

export default ClientList;
